//export const backend_url = "http://localhost:8000/";
export const backend_url = "https://backend.omakasevoyage.com/";
